import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { AuthWithoutOrgGuard } from './core/auth/guards/auth-without-org.guard';

// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

  // Redirect empty path to '/dashboard'
  {path: '', pathMatch: 'full', redirectTo: 'sign-in'},

  // Redirect signed in user to the '/example'
  {path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'example'},

  // Auth routes (guest)
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'confirmation-required',
        loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
      },
      {
        path: 'reset-password',
        loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)
      },
      {
        path: 'sign-in',
        loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
      },
      {
        path: 'sign-up',
        loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)
      },
      {
        path: 'generate-password',
        loadChildren: () => import('app/modules/auth/generate-password/generate-password.module').then(m => m.GeneratePasswordModule)
      },
      {
        path: 'verify-user',
        loadChildren: () => import('app/modules/auth/account-verified/account-verified.module').then(m => m.AccountVerifiedModule),
      },
      {
        path: 'resend-verification',
        loadChildren: (): any => import('app/modules/auth/resend-verification-link/resend-verification-link.module')
          .then(m => m.ResendVerificationLinkModule),
      },
      {
        path: 'unblock-user-password',
        loadChildren: (): any => import('app/modules/auth/unblock-generate-password/unblock-generate-password.module')
          .then(m => m.UnblockGeneratePasswordModule),
      },
      {
        path: 'verify-updated-email',
        loadChildren: (): any => import('app/modules/auth/verify-updated-email/verify-updated-email.module')
          .then(m => m.VerifyUpdatedEmailModule),
      },
    ]
  },
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty-with-toolbar'
    },
    children: [
      {
        path: 'org',
        loadChildren: () => import('app/modules/org/org.module').then(m => m.OrgModule)
      },
    ]
  },

  // Auth routes (logged in)
  {
    path: '',
    canActivate: [AuthWithoutOrgGuard],
    canActivateChild: [AuthWithoutOrgGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)
      },
      {
        path: 'unlock-session',
        loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)
      }
    ]
  },

  // Landing routes
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
    ]
  },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'user-profile',
        loadChildren: () => import('app/modules/auth/user-profile/user-profile.module').then(m => m.UserProfileModule)
      },
      {
        path: 'dashboard-admin',
        loadChildren: () => import('app/modules/dashboard-admin/dashboard-admin.module').then(m => m.DashboardAdminModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('app/modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'insights',
        loadChildren: () => import('app/modules/dashboard-insights/dashboard-insights.module').then(m => m.DashboardInsightsModule)
      },
      {
        path: 'analytics',
        loadChildren: () => import('app/modules/analytics/analytics.module').then(m => m.AnalyticsModule)
      },
      {
        path: 'internal',
        loadChildren: () => import('app/modules/internal-modules/internal-modules-routing.module').then(m => m.InternalModulesRoutingModule)
      }, {
        path: 'canvas',
        loadChildren: (() => (import('app/modules/org/org-canvas/org-canvas.module').then(m => m.OrgCanvasModule)))
      }, {
        path: 'sample',
        loadChildren: (() => (import('app/modules/sample/sample.module').then(m => m.SampleModule)))
      }, {
        path: 'reports',
        loadChildren: (() => (import('app/modules/reports/reports.module').then(m => m.ReportsModule)))
      }, {
        path: 'configuration',
        loadChildren: () => import('app/modules/customer-admin/customer-admin.module').then(m => m.CustomerAdminModule)
      }, {
        path: 'alert-policies',
        loadChildren: () => import('app/modules/org/org-alert-policies/org-alert-policies.module').then(m => m.OrgAlertPoliciesModule)
      }

    ]
  },
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      // 404 & Catch all
      {
        path: '404',
        pathMatch: 'full',
        loadChildren: () => import('app/modules/errors/error-404/error-404.module').then(m => m.Error404Module)
      },
      {
        path: '500',
        pathMatch: 'full',
        loadChildren: () => import('app/modules/errors/error-500/error-500.module').then(m => m.Error500Module)
      },
      {path: '**', redirectTo: '404'}
    ]
  },
];
